// extracted by mini-css-extract-plugin
module.exports = {"preview":"styles_preview__MdGvv"};